import { render, staticRenderFns } from "./ProductList2.vue?vue&type=template&id=0ae6f88e&scoped=true&"
import script from "./ProductList2.vue?vue&type=script&lang=js&"
export * from "./ProductList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae6f88e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ae6f88e')) {
      api.createRecord('0ae6f88e', component.options)
    } else {
      api.reload('0ae6f88e', component.options)
    }
    module.hot.accept("./ProductList2.vue?vue&type=template&id=0ae6f88e&scoped=true&", function () {
      api.rerender('0ae6f88e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Content/components/ProductList2.vue"
export default component.exports